interface OfferOrganizationWageSetLabelProps {
  organizationWageSetName: string | null | undefined;
  className?: string;
}

/** Names the wage set an offer's pinned wages came from, if any. */
export function OfferOrganizationWageSetLabel({
  organizationWageSetName,
  className,
}: OfferOrganizationWageSetLabelProps) {
  if (!organizationWageSetName) {
    return null;
  }
  return (
    <p className={className ?? "text-xs text-slate-500"}>
      Wages from <span className="font-medium">{organizationWageSetName}</span>
    </p>
  );
}
